import { ReactElement, useEffect } from 'react'
import Wizard from '../../Wizard'
import { ADD_PROMPT, useAddToListStore } from 'src/store/lists/AddToListStore'
import styled from 'styled-components'
import { CircularProgress } from '@mui/material'
import { defaultTheme } from 'src/theme'
import { I18n } from 'src/i18n'

const ValidationInProgress = (): ReactElement => {
  const addToListStore = useAddToListStore()
  const showStages = addToListStore.getSelectedPrompt() !== ADD_PROMPT.NONE

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Wizard title="validateItems" showStages={showStages}>
      <Content>
        <Loader size={96} />
        <Title>
          <I18n name="validatingItems" />
        </Title>
        <SubTitle>
          <I18n name="thisMayTakeAMoment" />
        </SubTitle>
      </Content>
    </Wizard>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 120px 64px 1200px 64px;
`

const Loader = styled(CircularProgress)`
  color: ${defaultTheme.colors.yellowReSort};
  margin: 0rem 0rem 2rem 0rem;
`

const Title = styled.div`
  font-family: Oswald;
  font-size: 36px;
  font-weight: 700;
  line-height: 60px;
  text-align: center;
  padding: 4px 0px 4px 0px;
`

const SubTitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  padding: 4px 0px 4px 0px;
`

export default ValidationInProgress
